import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';
import { SeedingContentTypeSchema } from './getSeedingMeRecruitment.api';

const DisplayStatusSchema = z.enum(['UPLOAD_REQUIRED', 'SHIPPING', 'PREPARING_PRODUCT']);

const ContentUploadDeadlineSchema = z
  .object({
    contentType: SeedingContentTypeSchema.nullable().optional(),
    deadlineAt: z.string().nullable().optional(),
  })
  .describe('ContentUploadDeadlineSchema');

const InProgressCampaignSchema = z
  .object({
    participationId: z.number(),
    campaignId: z.number(),
    displayStatus: DisplayStatusSchema,
    brandName: z.string(),
    goodsName: z.string(),
    goodsNo: z.number(),
    goodsImage: z.string(),
    selectedOptions: z.string(),
    contentUploadDeadline: ContentUploadDeadlineSchema.nullable().optional(),
  })
  .describe('InProgressCampaignSchema');

const GetInProgressCampaignsResponseDataSchema = z
  .object({
    campaigns: z.array(InProgressCampaignSchema),
    totalCount: z.number(),
  })
  .describe('GetInProgressCampaignsResponseDataSchema');

const GetInProgressCampaignsResponseSchema = createApiResponseSchema(
  GetInProgressCampaignsResponseDataSchema,
);

export type GetInProgressCampaignsResponse = z.infer<typeof GetInProgressCampaignsResponseSchema>;

export const getInProgressCampaigns = withApiErrorCapture(
  lazyPipe(
    async (): Promise<GetInProgressCampaignsResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetInProgressCampaignsResponse>(
          campaignsApiPath.getInProgressCampaigns,
        );
        return response;
      }),
    validateApiResponse(GetInProgressCampaignsResponseSchema),
  ),
);
